/** @param {import('./runApiCompletionStream.js').ApiCompletionCtx} ctx */
export function reportApiCompletionFailure(ctx, result) {
  const { tid, pendingId, session, setMessagesByThreadId } = ctx
  const message = result?.message || 'Chat request failed.'
  const text =
    result?.code === 'AETHER_ERROR' ? message : `Could not get a reply.\n\n${message}`
  setMessagesByThreadId((inner) => {
    const list = [...(inner[tid] ?? [])]
    const idx = list.findIndex((m) => m.id === pendingId)
    if (idx === -1) return inner
    const next = [...list]
    next[idx] = {
      ...next[idx],
      text,
      createdAt: Date.now(),
    }
    return { ...inner, [tid]: next }
  })
  session.dispose()
}
